<flow-header class="w-full mb-6" [title]="'channels.title' | translate">
  <div class="flex-1">
    <ng-container *ngIf="isAdmin">
      <flow-button
        theme="primary"
        variation="fill"
        *flowHasPermission="[Permissions.UpdateChannelAdmin]; disabled true;"
        [routerLink]="['/channels/create']">
        {{'global.add' | translate}}
      </flow-button>
    </ng-container>
  </div>
  <div class="flex flex-1 justify-end items-center">
    <app-icon
      mat-ripple
      class="cursor-pointer rounded-full"
      iconName="question"
      size="md"
      fill="#1f5792"
      (click)="toggleSidePanel()"></app-icon>
  </div>
</flow-header>

<form *ngIf="isAdmin" [formGroup]="filterForm" class="bg-white rounded-md flex justify-between">
  <div class="mr-5 flex flex-col">
    <mat-label>{{ "manage.filters.customers" | translate }}</mat-label>
    <mat-form-field>
      <mat-select formControlName="customers" placeholder="{{'channels.customer' | translate}}" multiple>
        <mat-option *ngFor="let customer of customers" [value]="customer.id">
          {{ customer.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>

<flow-channel-filter-section *ngIf="!!filterValues?.customers?.length" (onFilter)="searchChannels($event)"></flow-channel-filter-section>
<div *ngIf="dataSource?.data?.length && !!filterValues?.customers?.length; else selectCustomer">
  <mat-paginator
    class="mb-4"
    (page)="handlePageEvent($event)"
    [length]="totalCount"
    [pageIndex]="params.pageNumber"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="params.pageSize"
    showFirstLastButtons></mat-paginator>

  <table
    mat-table
    [dataSource]="dataSource"
    (matSortChange)="handleSortEvent($event)"
    multiTemplateDataRows
    class="table-hover"
    matSort
    matSortActive="name"
    matSortDirection="asc">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.id' | translate}}</th>
      <td mat-cell *matCellDef="let channel">{{channel.id}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.name' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        <div class="flex items-center gap-[4px]">
          <div class="traffic-light" [ngClass]="channel.isActive ? 'bg-[#177578] ' : 'bg-[#FC4B47]'"></div>
          <div>{{channel.name}}</div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.customer' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        {{channel.customerName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="coordinates">
      <th *matHeaderCellDef mat-header-cell>{{ 'channels.table.coordinates' | translate }}</th>
      <td *matCellDef="let channel" mat-cell>
        <div
          class="text-brand-chathams-blue underline cursor-pointer"
          matTooltip="{{channel.latitude && channel.longitude ? ('channels.table.coordinatesInfo' | translate: {latitude: channel.latitude, longitude: channel.longitude}) : '' }}">
          <a (click)="redirectToMaps(channel.latitude, channel.longitude)">{{'screens.table.view' | translate}}</a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.city' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        {{channel.city}}
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.address' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        {{channel.address}}
      </td>
    </ng-container>

    <ng-container matColumnDef="postalCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.postalCode' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        {{channel.postalCode}}
      </td>
    </ng-container>

    <ng-container matColumnDef="lineOfBusiness">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'channels.table.lineOfBusiness' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        {{ 'createChannel.lineOfBusiness.' + channel.lineOfBusiness.name | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="isForecastEnabled">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'channels.table.forecasts' | translate }}</th>
      <td *matCellDef="let channel" mat-cell>
        <ng-container *ngIf="channel?.isForecastEnabled; then greenCheck else redX "></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="hasClosedDays">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'channels.table.closedDays' | translate }}</th>
      <td *matCellDef="let channel" mat-cell>
        <ng-container *ngIf="channel?.hasClosedDays; then greenCheck else redX "></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="weatherData">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'channels.table.weatherData' | translate }}</th>
      <td *matCellDef="let channel" mat-cell>
        <ng-container *ngIf="channel?.isWeatherCollectionEnabled then greenCheck else redX "></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'channels.table.status' | translate}}</th>
      <td mat-cell *matCellDef="let channel">
        <mat-slide-toggle
          *flowHasPermission="[Permissions.UpdateChannelAdmin]; disabled true;"
          mat-icon-button
          [matTooltip]="'channels.table.activate' | translate"
          matTooltipPosition="above"
          (click)="onToggle($event, channel, channel.isActive)"
          [(ngModel)]="channel.isActive"
          color="primary"
          labelPosition="before"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions-col"></th>
      <td mat-cell *matCellDef="let channel">
        <button [matMenuTriggerFor]="menu" mat-icon-button>
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <a *flowHasPermission="[Permissions.UpdateChannelAdmin]; disabled true;" [routerLink]="['/channels', channel.id]" mat-menu-item>
            {{'global.edit' | translate}}
          </a>
          <a
            *flowHasPermission="[Permissions.UpdateChannelAdmin]; disabled true;"
            mat-menu-item
            (click)="onDeleteClick($event, channel.id)">
            <span class="text-red-500">{{ 'global.delete' | translate }}</span>
          </a>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row class="bg-gray-50" *matHeaderRowDef="displayedColumns"></tr>

    <tr
      mat-row
      *matRowDef="let channel; columns: displayedColumns; let odd = odd"
      [ngClass]="{'bg-gray-50': odd}"
      (dblclick)="redirectToEditPage(channel.id)"></tr>
  </table>
</div>

<ng-template #selectCustomer>
  <div
    *ngIf="dataSource?.data?.length === 0 && !filterValues?.customers?.length; else noData"
    [style.height.px]="200"
    class="flex justify-center items-center">
    <h2>{{'channels.emptyMessage' | translate}}</h2>
  </div>
</ng-template>
<ng-template #noData>
  <flow-no-data [title]="'global.noDataFound'" [label]="'global.noDataFoundInfo'"></flow-no-data>
</ng-template>

<ng-template #redX>
  <app-icon fill="none" iconName="red-x" size="md"></app-icon>
</ng-template>

<ng-template #greenCheck>
  <app-icon fill="none" iconName="green-check-mark" size="md"></app-icon>
</ng-template>
